<template>
  <div>
    <div class="invites-none" v-if="invites.length === 0">暂无邀请</div>
    <el-card v-else :key="invite.id" v-for="invite of invites" shadow="hover">
      <div class="item">
        <router-link :to="getRoute(invite.invite_key)">{{
          getHref(invite.invite_key)
        }}</router-link>
        <span>{{ roleLabel(invite.role) }}</span>
        <span v-if="invite['is_used']">已使用</span>
        <el-button v-else size="small" @click="copy(invite.invite_key)"
          ><i class="el-icon-document"></i
        ></el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { RoleCNMixin } from "@/mixins";
export default {
  name: "UserInviteSummary",
  props: ["invites"],
  mixins: [RoleCNMixin],
  methods: {
    getRoute(invite_key) {
      return { name: "register", query: { invite_key } };
    },
    getHref(invite_key) {
      let r = this.getRoute(invite_key);
      let path = this.$router.resolve(r).href;
      return window.location.origin + "/" + path;
    },
    copy(invite_key) {
      let href = this.getHref(invite_key);
      this.$copyText(href).then(() => {
        this.$message({
          type: "info",
          center: true,
          message: "已复制",
          duration: 500
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.invites-none {
  background-color: #f3f3f3;
  font-size: 1.5em;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
a {
  text-decoration: none;
  color: inherit;
  &:visited,
  &:hover,
  &:active {
    color: inherit;
  }
}
</style>
